import { useCallback } from "react";
import type { AtmosphereWheelsType } from "../../utils/types/AtmosphereType";
import { type CarConfigDispatchType, useCarConfigSelector } from "../../redux/store";
import { setWheels } from "../../redux/slices/CarConfigBasketSlice";
import { trackWheelAddToBasket } from "../../utils/tracking";
import { useDispatch } from "../../../../../shared-logic/redux/store";
import { setActiveSpin, SpinnerType } from "../../redux/slices/CarConfigSpinNavigationSlice";

const useAphLbxWheel = (
    wheel: AtmosphereWheelsType,
): { onClick: () => void; isSelectable: boolean; isActive: boolean } => {
    const dispatch = useDispatch<CarConfigDispatchType>();
    const carWheels = useCarConfigSelector((state) => state.items.wheels);
    const basketWheel = useCarConfigSelector((state) => state.basket.wheel);

    const currentWheel = carWheels.find((carWheel) => carWheel.id === wheel.id);
    const isActive = wheel.id === basketWheel.id;
    const activeSpinner = useCarConfigSelector((state) => state.carConfigSpinNavigation.activeSpin);

    const onClick = useCallback(() => {
        if (activeSpinner !== SpinnerType.Car) {
            dispatch(setActiveSpin(SpinnerType.Car));
        }

        trackWheelAddToBasket();
        if (currentWheel) {
            dispatch(setWheels({ wheel: currentWheel }));
        }
    }, [currentWheel, activeSpinner]);

    return {
        onClick,
        isSelectable: !!currentWheel,
        isActive,
    };
};

export default useAphLbxWheel;
